import { render, staticRenderFns } from "./ProductPickerModal.vue?vue&type=template&id=15f97ae2&"
import script from "./ProductPickerModal.vue?vue&type=script&lang=js&"
export * from "./ProductPickerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports